/**
 * Single source of truth for the artifacts inside each section.
 *
 * The companion to `sections.ts`: that array owns the sections, this one
 * owns what is *in* them. Both index pages and the home grid read from here,
 * which is the whole point — the home page used to carry a hand-written
 * `COUNTS` table saying how many items each section held, and by 2026-08-30 it
 * said `02` for chess (three pages) and `05` for sound (three pages). Nothing
 * could have caught that but a person reading the front page.
 *
 * Adding an artifact: append to the section's array here, add its route in
 * `App.tsx`, and the section index and the home count both follow.
 *
 * `number` is the card's own label (`s·01`) and is deliberately not derived
 * from the array index: retiring an artifact should not renumber its
 * neighbours, and the standalone sound pages retired in item 8 are the reason
 * that matters. It is a name, not a position.
 */

export interface Artifact {
  number: string
  title: string
  blurb: string
  href: string
  status?: 'live' | 'soon'
}

/**
 * What the home page counts.
 *
 * A `soon` card is drawn at half opacity and is not a link, so counting it
 * would have the front page promise something you cannot open. The count is of
 * artifacts you can actually go and use.
 */
export const liveCount = (list: readonly Artifact[]): number =>
  list.filter((a) => a.status !== 'soon').length
